import '../../style/index.css';
import './index.css'; // style dependencies

import '../../tabs/style/css';